const initialState = {
  user: {
    pk: null,
    ubicacion: null,
    curt: null,
    cuentadepredial: null,
    clave_catastral: null,
    nombrecompletopropietario: null,
    cargos: null,
    OPD: null,
    SEGURO: null,
    id_consulta: null,
    tiene_seguro: 0,
    tiene_opd: 0,
  },
  data: [],
  allItemsChecked: false,
  recibo: null,
};

const mutations = {
  SET_USER(state, payload) {
    state.user = payload;
  },
  SET_DATA(state, payload) {
    state.data = payload;
  },
  SET_ALL_ITEM_CHECKED(state, payload) {
    state.allItemsChecked = payload;
  },
  SET_DATA_ITEM_DISABLED(state, payload) {
    state.data[payload.idx].disabled = payload.state;
  },
  SET_DATA_ITEM_CHECKED(state, payload) {
    state.data[payload.idx].checked = payload.state;
  },
  SET_RECIBO(state, payload) {
    state.recibo = payload;
  },
};

const actions = {
  SET_USER({ commit }, payload) {
    if (typeof payload === 'object') {
      commit('SET_USER', payload);
    }
  },
  SET_DATA({ commit }, payload) {
    if (Array.isArray(payload)) {
      commit('SET_DATA', payload);
    }
  },
  SET_ALL_ITEM_CHECKED({ commit }, payload) {
    if (typeof payload === 'boolean') {
      commit('SET_ALL_ITEM_CHECKED', payload);
    }
  },
  SET_DATA_ITEM_DISABLED({ commit }, payload) {
    const { idx, state } = payload;
    if (typeof state === 'boolean' && typeof idx === 'number') {
      commit('SET_DATA_ITEM_DISABLED', payload);
    }
  },
  SET_DATA_ITEM_CHECKED({ commit }, payload) {
    const { idx, state } = payload;
    if (typeof state === 'boolean' && typeof idx === 'number') {
      commit('SET_DATA_ITEM_CHECKED', payload);
    }
  },
  SET_RECIBO({ commit }, payload) {
    if (typeof payload === 'string' || payload === null) {
      commit('SET_RECIBO', payload);
    }
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  namespaced: true,
};
